import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=0faa5d73"
import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports